import React from 'react';
import './About.scss';
import { safeHtml } from '../../../../services/helpers';
import StrapiImageWithSkeleton from '../../../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';

export default function About({ strapiData }) {
    return (
        <section className='ebook-about'>
            <div className="ebook-about__text" dangerouslySetInnerHTML={safeHtml(strapiData.Texte)} />
            <div className="ebook-about__image-container">
                <div className="ebook-about__image-wrapper">
                    <StrapiImageWithSkeleton
                        picture={strapiData.Photo}
                        loading="lazy"
                        size='small'
                    />
                </div>
                <div className="ebook-about__image-shadow"></div>
            </div>
        </section>
    )
}
